import React, { Component } from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";

class KsuTab extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
      },
    },
    {
      name: "kodeKSU",
      label: "Kode KSU",
    },
    {
      name: "namaKSU",
      label: "Nama KSU",
    },
    {
      name: "kategoriKSU",
      label: "Kategori",
    },
    {
      name: "qty",
      label: "Qty",
    },
    {
      name: "qrCodeKSU",
      label: "QR Code",
    },
  ];

  render() {
    return (
      <SimpleDataTable
        data={this.props.data}
        columns={this.tableColumns}
        rowsPerPage={5}
        options={{ serverSide: false }}
      />
    );
  }
}

export default KsuTab;
